import { buildLoader } from '../util/GenericLoader';
import fetchAllPointTypesActionCreator from '../../redux/actions/pointtypes';

export default buildLoader(fetchAllPointTypesActionCreator);
